<template>
  <div>
    <a-drawer :width="'100%'" placement="right" :visible="visible" :closable="false">
      <div v-if="iphoneAgent && !alreadygetPhoto" id="app" class="web-camera-container bg" style="text-align:center;">
        <a @click="mapview()" style="color:white!important;font-size: large;">Accurating Coordinate: <br />Lat {{
          coordinate.latitude }}, Long {{ coordinate.longitude }}</a>
        <br />
        <a-button @click="StartGPS">Refresh GPS</a-button>
        <br />
        <a-button @click="toGetPhoto">Lock Coordinate</a-button>
      </div>
      <div v-else id="app" class="web-camera-container">
        <div v-show="isCameraOpen && isLoading" class="camera-loading">
          <ul class="loader-circle">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>

        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash': isShotPhoto }">

          <div class="camera-shutter" :class="{ 'flash': isShotPhoto }"></div>

          <video id="videosrc" :class="this.cameraSource == 'user' ? 'videouser' : ''" v-show="!isPhotoTaken" ref="camera"
            :width="getCameraWidth" :height="getCameraHeight" autoplay playsinline muted :style="getstyleVideo"></video>

          <canvas id="photoTaken" ref="canvas" :width="camerawidth" :height="cameraheight"
            style="display:none!important"></canvas>

          <img v-show="isPhotoTaken" id="resultimage" :width="getCameraWidth" :height="getCameraHeight" />
        </div>
      </div>
      <div class="camera-button">
        <!-- <button type="button" @click="back">home</button>
        <button type="button" class="button is-rounded" :class="{ 'is-primary' : !isCameraOpen, 'is-danger' : isCameraOpen}" @click="toggleCamera">
          <span v-if="!isCameraOpen">Open Camera</span>
          <span v-else>Close Camera</span>
      </button> -->
        <img class="m-brand" id="logo_harmoni" src="@/assets/logo.png" alt="logo-mobile" />
        <br />
        <div v-if="!iphoneAgent" :class="screenPotrait ? '' : 'gps_bottom'"
          style="background-color:black;color:white;padding:3px;border-radius: 5px;">
          GPS : <span id="latitude">{{ coordinate.latitude }}</span>° latitude,
          <span id="longitude"> {{ coordinate.longitude }}</span>° longitude.&nbsp;
        </div>
      </div>

      <!-- <div :class="getCameraHeight<getCameraWidth? 'other-landscape' : 'other-potrait'">
      <a-button size="large" type="primary" shape="circle" class="icon-button" @click="back">
        <a-icon type="ellipsis" style="font-size: xx-large;"/>
      </a-button>
    </div>

    <div :class="getCameraHeight<getCameraWidth? 'shoot-landscape' : 'shoot-potrait'" :style="getCameraHeight<getCameraWidth? 'top:'+((getCameraHeight/2)-30)+'px!important' : ''">
      <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
        <a-button size="large" type="primary" shape="circle" class="icon-button" @click="takePhoto">
          <a-icon type="camera" style="font-size: xx-large;"/>
        </a-button>
      </div>
      
      <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
        <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
          Download
        </a>
      </div>
    </div>

    <div :class="getCameraHeight<getCameraWidth? 'back-landscape' : 'back-potrait'">
      <a-button size="large" type="primary" shape="circle" class="icon-button" @click="back">
        <a-icon type="rollback" style="font-size: xx-large;"/>
      </a-button>
    </div> -->
      <!-- <div :class="getCameraHeight<getCameraWidth? 'menu-landscape advance-menu' : 'menu-potrait advance-menu'">
      <div style="position:initial;width:100%">
          <a-slider :min="0" :max="100" style="width:70%;"/>
      </div>
    </div> -->
      <div v-if="alreadygetPhoto" :class="getCameraHeight < getCameraWidth ? 'menu-landscape' : 'menu-potrait'">
        <div class="button-list">
          <a-button size="large" type="primary" shape="circle" class="icon-button" @click="advancemenu">
            <a-icon type="ellipsis" style="font-size: xx-large;" />
          </a-button>
        </div>
        <div class="button-list">
          <a-button size="large" type="primary" shape="circle" class="icon-button" @click="takePhoto">
            <a-icon type="camera" style="font-size: xx-large;" />
          </a-button>
        </div>
        <div class="button-list">
          <a-button size="large" type="primary" shape="circle" class="icon-button" @click="back">
            <a-icon type="rollback" style="font-size: xx-large;" />
          </a-button>
        </div>
      </div>
    </a-drawer>
    <a-drawer placement="bottom" :closable="false" :visible="visibleAdvancedMenu" @close="onClose"
      style="background-color:none!important">
      <div style="padding: 24px!important;">
        <!-- <a-slider id="idZoombutton" v-model="slideZoom" @afterChange="zoomChange" /> -->
        <a-radio-group v-model="cameraSource" @change="changecamera" button-style="solid" class="margin-top">
          <a-radio-button value="user">Front Camera</a-radio-button>
          <a-radio-button value="environment">Main Camera</a-radio-button>
        </a-radio-group>
        <!-- <a-select v-model="cameraSource" class="margin-top w-full">
        cameraSource
        <a-select-option value="front">Front</a-select-option>
        <a-select-option value="back">Back</a-select-option>
      </a-select> -->
      </div>
    </a-drawer>

    <a-modal v-model="entriDescription" @ok="sendAbesenPhoto" @cancel="cancelAbesonPhoto" :footer="null"
      :dialog-style="{ top: '70%' }">
      <span slot="title">
        Keterangan
      </span>

      <a-textarea placeholder="Isi keterangan" :autoSize="{ minRows: 3, maxRows: 4 }" v-model="keterangan" />
      <a-button class="w-full m-top" type="primary" @click="sendAbesenPhoto" :loading="loadingSendphoto">Kirim</a-button>
    </a-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
  },
  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#',
      visible: false,
      slideZoom: 0,
      visibleAdvancedMenu: false,
      cameraSource: "user",
      cameraDeviceID: null,
      coordinate: {
        latitude: 0,
        longitude: 0
      },
      pollingGPS: null,
      alreadygetPhoto: false,
      lockGPSDate: null,
      keterangan: "",
      entriDescription: false,
      postData: null,
      loadingSendphoto: false,
      keyResolution: 0,
      resolution: [
        // {
        //   width: 4000,
        //   height: 4000
        // },
        {
          width: 1280,
          height: 720
        },
        {
          width: 640,
          height: 480
        },
        {
          width: 320,
          height: 240
        },
      ]
    };
  },
  mounted() {
    Event.$on("refreshCameraOption", this.refreshCameraOption);
    if (this.modetestlayar) {
      alert(this.getCameraWidth + "," + this.getCameraHeight);
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.coordinate.latitude = position.coords.latitude;
        this.coordinate.longitude = position.coords.longitude;
      });
    }
    //this.findMaximum_WidthHeight_ForCamera();
    //alert(x.zoom)
    if (!this.isMobile) {
      this.$router.go(-1);
      this.displayMessageValue("error-basic", "Fitur Spesifik hanya untuk mobile!");
    } else {
      //window.scrollTo(0, 1);
      // window.addEventListener("load", function () {
      //   // Set a timeout...
      //   setTimeout(function () {
      //     // Hide the address bar!
      //     window.scrollTo(0, 1);
      //   }, 0);
      // });

      this.visible = true;
      if (!this.iphoneAgent && !this.alreadygetPhoto) {
        this.alreadygetPhoto = true;
        this.toggleCamera();
      }

      // var element = document.querySelector("body");
      // element.requestFullscreen();

      window.addEventListener("resize", this.resize);
      // window.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      // window.mozRequestFullScreen();
      // window.msRequestFullscreen();
      // window.requestFullscreen(); // standard

      // if (!navigator.mediaDevices.enumerateDevices) {
      //   console.log("enumerateDevices() not supported.");
      // } else {
      //   // List cameras and microphones.
      //   this.cameraDeviceID
      //   navigator.mediaDevices
      //     .enumerateDevices()
      //     .then((devices) => {
      //       devices.forEach((device) => {
      //         console.log(`${device.kind}: ${device.label} id = ${device.deviceId}`);
      //         alert(`${device.label}` + `${device.deviceId}`);
      //       });
      //     })
      //     .catch((err) => {
      //       console.error(`${err.name}: ${err.message}`);
      //     });
      //}

      this.pollingGPS = setInterval(() => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            this.coordinate.latitude = position.coords.latitude;
            this.coordinate.longitude = position.coords.longitude;
          });
        }
      }, 2000);
    }
  },
  created() {
  },
  beforeDestroy() {
    Event.$on("refreshCameraOption", this.refreshCameraOption);
    clearInterval(this.pollingGPS);
  },
  computed: {
    ...mapGetters(["getAuth"]),
    screenPotrait() {
      return window.innerWidth > window.innerHeight ? false : true;
    },
    iphoneAgent() {
      // let result = false;
      // if (navigator.userAgent) {
      //   if (navigator.userAgent.toLowerCase().indexOf("iphone")>=0){
      //     result = true;
      //   }
      // }
      // return result;
      return false;
    },
    getCameraHeight() {
      return window.innerHeight;
    },
    innerHeight() {
      return window.innerHeight;
    },
    getCameraWidth() {
      return window.innerWidth;
    },
    innerWidth() {
      return window.innerWidth;
    },
    getstyleVideo() {
      return "width: 100%px;object-fit: contain;"
      //none;cover;scale-down;contain;fill
    },
    camerawidth() {
      let result = 0;
      // if ((window.innerWidth== 450 && window.innerHeight ==719)) {
      //   result = 640;
      // } else {
      //   //result = this.screenPotrait ? this.getCameraHeight : this.getCameraWidth
      //   result = 4000
      // }
      result = this.resolution[this.keyResolution].width
      return result;
    },
    cameraheight() {
      let result = 0;
      // if ((window.innerWidth == 719 && window.innerHeight == 450)) {
      //   result = 719;
      // } else {
      //   //result = this.screenPotrait ? this.getCameraWidth : this.getCameraHeight
      //   result = 4000
      // }
      result = this.resolution[this.keyResolution].height
      return result;
    },
    modetestlayar() {
      let result = false;
      if (this.$route.meta.modetestlayar) {
        result = true;
      }
      return result;
    }
  },
  methods: {
    moment,
    refreshCameraOption() {
      // alert( "mlaku" + this.resolution[this.keyResolution].width)
      this.createCameraElement();
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const supports = navigator.mediaDevices.getSupportedConstraints();
      if (!supports.pan) {
        // Browser not supports camera PTZ.
        //this.displayMessageValue('error-other','Not Support Pan');
      }
      if (!supports.tilt) {
        // Browser not supports camera PTZ.
        //this.displayMessageValue('error-other','Not Support Tilt');
      }
      if (!supports.zoom) {
        // Browser not supports camera PTZ.
        //this.displayMessageValue('error-other','Not Support Zoom');
      }
      if (!supports['facingMode']) {
        // Browser not supports camera PTZ.
        //this.displayMessageValue('error-other', 'Not Support facingMode');
      }

      const constraints = (window.constraints = {
        audio: false,
        video: {
          //width: screen.width,
          //height: screen.height,
          // width: { ideal: 350 },
          // height: { ideal: 719 },

          width: {
            // min: this.camerawidth,
            // ideal: this.camerawidth,
            exact: this.screenPotrait ? this.cameraheight : this.camerawidth,
          },
          height: {
            // min: this.cameraheight,
            // ideal: this.cameraheight,
            exact: this.screenPotrait ? this.camerawidth : this.cameraheight,
          },

          //width: { exact: (this.screenPotrait ? this.getCameraHeight : this.getCameraWidth)},
          //height: { exact: (this.screenPotrait ? this.getCameraWidth : this.getCameraHeight)},

          pan: false, tilt: false, zoom: false,
          //facingMode: "environment",
          facingMode: {
            exact: this.cameraSource
          },
          //"user" : "environment"
          //frameRate: { ideal: 10, max: 15 }
        },
        // bandwidthProfile: {
        //   video: {
        //     mode: 'collaboration',
        //   },
        // },
      });


      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.isLoading = false;

          // Get video track capabilities and settings.
          const [videoTrack] = stream.getVideoTracks();
          const capabilities = videoTrack.getCapabilities();
          const settings = videoTrack.getSettings();

          if ("pan" in settings) {
            // const input = document.querySelector("input[type=range]");
            // input.min = capabilities.pan.min;
            // input.max = capabilities.pan.max;
            // input.step = capabilities.pan.step;
            // input.value = settings.pan;

            // input.addEventListener("input", async () => {
            //   await videoTrack.applyConstraints({ advanced: [{ pan: input.value }] });
            // });
          }

          if ("tilt" in settings) {
            // similar for tilt...
          }
          if ("zoom" in settings) {
            // similar for zoom...   
          }

          this.$refs.camera.srcObject = stream;
        })
        .catch(error => {
          this.isLoading = false;
          this.displayMessageValue('error-other', error);
          if (error && (this.keyResolution <= this.resolution.length)) {
            alert(this.keyResolution)
            this.keyResolution += 1;
            Event.$emit("refreshCameraOption");
          }
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },

    takePhoto() {
      if (this.iphoneAgent) {
        let timenow = moment();
        let ressulttime = timenow.diff(this.lockGPSDate, "minutes");
        if (ressulttime > 3) {
          this.displayMessageValue('error-basic', "GPS Coordinate Lock Is Expired!");
          this.$router.go();
        }
      }
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      if (this.cameraSource == 'user') { //if kamera front:'user' kamera back:'environment'
        context.translate(this.camerawidth, 0);
        context.scale(-1, 1);
      }
      context.drawImage(this.$refs.camera, 0, 0, this.camerawidth, this.cameraheight);

      const watermark = context;
      watermark.globalAlpha = 0.5;
      if (this.cameraSource == 'user') {//if kamera front:'user' kamera back:'environment'
        context.translate(this.camerawidth, 0);
        watermark.scale(-1, 1);
      }
      var w = document.getElementById('logo_harmoni');
      watermark.drawImage(w, 5, 5, 132, 30);

      let long = this.coordinate.longitude;
      let lat = this.coordinate.latitude;

      //     //this.watermarkText(watermarkx, "GPS : " + lat + "&#x2109latitude, " + long + "&#x2109longitude");
      //     //this.watermarkText(watermark, "jos gandos" );

      const context2 = watermark;
      context2.font = "12px bold Georgia";
      context2.fillStyle = "yellow";
      context2.shadowColor = "black";
      context2.shadowBlur = 7;
      context2.lineWidth = 5;
      context2.shadowBlur = 0;
      context2.textAlign = "left";
      context2.fillText("GPS : " + lat + "° latitude, " + long + "° longitude", 5, 55);

      // let svgdataUriStr = 'data:image/svg+xml;base64,' + window.btoa(
      //   '<svg xmlns="http://www.w3.org/2000/svg" height="25" width="200">' +
      //   '<foreignObject width="100%" height="100%">' +
      //   '<div xmlns="http://www.w3.org/1999/xhtml">' +
      //   '<div style="position: absolute;' +
      //   'left: 0;' +
      //   'top: 0;' +
      //   'font-family: Tahoma;' +
      //   'font-size: 10pt;' +
      //   'background: #000;' +
      //   'color: #fff;' +
      //   'padding: 0.25em;' +
      //   'border-radius: 0.25em;' +
      //   'margin: 0 0.125em 0.125em 0;' +
      //   '">jos gandos</div>' +
      //   '</div>' +
      //   '</foreignObject>' +
      //   '</svg>'
      // );

      // const context3 = watermark;
      // var img = document.createElement("img");
      // img.src = svgdataUriStr;
      // let aaaa = img
      // context3.drawImage(aaaa, 20, 20, 200, 25);


      this.postData = new FormData();
      this.postData.append("tlc", this.getAuth.username);
      this.postData.append("longitude", long);
      this.postData.append("latitude", lat);
      this.postData.append("device", navigator.userAgent);

      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
      this.postData.append("file_photo", canvas);
      //this.setcovertofit();
      var image = document.getElementById("resultimage");
      image.src = canvas;

      this.stopCameraStream();

      this.entriDescription = true;
    },

    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);
    },

    back() {
      this.visible = false;
      this.$router.push({
        name: "beranda"
      });
    },
    advancemenu() {
      this.visibleAdvancedMenu = true;
    },
    onClose() {
      this.visibleAdvancedMenu = false;
    },
    resize() {
      let tempscreenPotrait = window.innerWidth > window.innerHeight ? false : true
      if (this.screenPotrait != tempscreenPotrait) {
        this.$router.go();
      }
    },
    watermarkText(elemImage, text) {
      let svgdataUriStr = 'data:image/svg+xml;base64,' + window.btoa(
        '<svg xmlns="http://www.w3.org/2000/svg" height="' + 25 + '" width="' + 200 + '">' +
        '<foreignObject width="100%" height="100%">' +
        '<div xmlns="http://www.w3.org/1999/xhtml">' +
        '<div style="position: absolute;' +
        'left: 0;' +
        'top: 0;' +
        'font-family: Tahoma;' +
        'font-size: 10pt;' +
        'background: #000;' +
        'color: #fff;' +
        'padding: 0.25em;' +
        'border-radius: 0.25em;' +
        'margin: 0 0.125em 0.125em 0;' +
        '">' + text + '</div>' +
        '</div>' +
        '</foreignObject>' +
        '</svg>'
      );

      let img = new Image();
      img.onload = function () {
        const canvased = document.createElement('canvas');
        const ctxed = canvased.getContext("2d");
        //ctxed.scale(-1, 1);
        ctxed.drawImage(img, 0, 0, 200, 25);
      };
      img.src = svgdataUriStr;
      elemImage.drawImage(img, 0, 0, 200, 25);
    },
    zoomChange(val) {
      navigator.mediaDevices
        .getUserMedia()
        .then(stream => {
          this.isLoading = false;

          // Get video track capabilities and settings.
          const [videoTrack] = stream.getVideoTracks();
          const capabilities = videoTrack.getCapabilities();
          const settings = videoTrack.getSettings();

          if ("pan" in settings) {
            // const input = document.querySelector("input[type=range]");
            // input.min = capabilities.pan.min;
            // input.max = capabilities.pan.max;
            // input.step = capabilities.pan.step;
            // input.value = settings.pan;

            // input.addEventListener("input", async () => {
            //   await videoTrack.applyConstraints({ advanced: [{ pan: input.value }] });
            // });
          }

          if ("tilt" in settings) {
            // similar for tilt...
          }
          if ("zoom" in settings) {
            // similar for zoom...
            const input = document.querySelector("input[type=range]");
            input.min = capabilities.zoom.min;
            input.max = capabilities.zoom.max;
            input.step = capabilities.zoom.step;
            input.value = settings.zoom;
            console.log("wes zoom")
            input.addEventListener("input", async () => {
              await videoTrack.applyConstraints({ advanced: [{ zoom: 500 }] });
            });
          }

          this.$refs.camera.srcObject = stream;

        })
        .catch(error => {
          console.log(error)
          this.isLoading = false;
          //this.displayMessageValue('error-other',error);
        });
    },
    changecamera(e) {
      //alert(a.target.value)
      this.createCameraElement();
      var element = document.getElementById("videosrc");
      element.classList.remove("videouser");
      if (e.target.value == 'user') {
        element.classList.add("videouser");
      }
    },
    findMaximum_WidthHeight_ForCamera() {
      var ResolutionsToCheck = [
        { width: 160, height: 120 },
        { width: 320, height: 180 },
        { width: 320, height: 240 },
        { width: 640, height: 360 },
        { width: 640, height: 480 },
        { width: 393, height: 576 },
        { width: 784, height: 576 },
        { width: 1280, height: 720 },
        { width: 1280, height: 393 },
        { width: 1280, height: 800 },
        { width: 1280, height: 900 },
        { width: 1280, height: 1000 },
        { width: 1920, height: 1080 },
        { width: 1920, height: 1200 },
        { width: 2560, height: 1440 },
        { width: 3840, height: 2160 },
        { width: 4096, height: 2160 }
      ];

      var left = 0;
      var right = ResolutionsToCheck.length;
      var selectedWidth;
      var selectedHeight;
      var mid;

      console.log("left:right = ", left, ":", right);
      if (left > right) {
        console.log("Selected Height:Width = ", selectedWidth, ":", selectedHeight);
        return;
      }

      mid = Math.floor((left + right) / 2);

      var temporaryConstraints = {
        "audio": false,
        "video": {
          "mandatory": {
            "minWidth": ResolutionsToCheck[mid].width,
            "minHeight": ResolutionsToCheck[mid].height,
            "maxWidth": ResolutionsToCheck[mid].width,
            "maxHeight": ResolutionsToCheck[mid].height
          },
          "optional": []
        }
      }

      navigator.mediaDevices.getUserMedia(temporaryConstraints).then(this.checkSuccess).catch(this.checkError);
    },
    checkSuccess(stream) {
      // console.log("Success for --> ", mid, " ", ResolutionsToCheck[mid]);
      // selectedWidth = ResolutionsToCheck[mid].width;
      // selectedHeight = ResolutionsToCheck[mid].height;

      // left = mid + 1;

      // for (let track of stream.getTracks()) {
      //   track.stop()
      // }

      // FindMaximum_WidthHeight_ForCamera();
    },
    checkError(error) {
      // console.log("Failed for --> " + mid, " ", ResolutionsToCheck[mid], " ", error);
      // right = mid - 1;

      // FindMaximum_WidthHeight_ForCamera();
    },
    setcovertofit() {
      document.getElementById("photoTaken").setAttribute('width', window.innerWidth);
      document.getElementById("photoTaken").setAttribute('height', window.innerHeight);
    },
    setcovertoreal() {
      document.getElementById("photoTaken").setAttribute('width', this.getCameraWidth);
      document.getElementById("photoTaken").setAttribute('height', this.getCameraHeight);
    },
    mapview() {
      window.open("https://www.google.com/maps/search/" + this.coordinate.latitude + "++" + this.coordinate.longitude, "_blank");
    },
    toGetPhoto() {
      this.alreadygetPhoto = true;
      this.lockGPSDate = moment();
      this.toggleCamera();
    },
    StartGPS() {
      if (navigator.geolocation) {
        this.pollingGPS = setInterval(() => {
          navigator.geolocation.getCurrentPosition((position) => {
            this.coordinate.latitude = position.coords.latitude;
            this.coordinate.longitude = position.coords.longitude;
          });
        }, 2000);
      }
    },
    sendAbesenPhoto() {
      this.loadingSendphoto = true;
      if (this.modetestlayar) {
        console.log("test layar");
      } else {
        this.postData.append("description", this.keterangan);

        if (this.postData.get("longitude") == 0 && this.postData.get("latitude") == 0) {
          this.displayMessageValue('error-basic', "GPS Coordinate Wrong, Please check whether GPS is active!");
        } else if (this.keterangan == null || this.keterangan == undefined) {
          this.displayMessageValue('error-basic', "Keterangan tidak boleh kosong!");
        } else {
          axios({
            method: "post",
            url: this.$serviceUrl + "Absensi/absen",
            processData: false,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey
            },
            data: this.postData
          })
            .then(() => {
              // this.stopCameraStream();
              // console.log(response);
              this.$router.push({
                name: "log.absensi"
              });
              this.$notification.success({
                message: "Sukses",
                description: "Absensi via Photo telah berhasil!"
              });
              this.loadingSendphoto = false;
            })
            .catch(err => {
              this.loadingSendphoto = false;
              console.log(err);
              //this.setcovertoreal();
              if (err.response.data.message === false) {
                this.displayMessageValue('error-basic', err.response.data.message);
              } else {
                let responses = Object.assign({}, err.response);
                this.displayMessageValue('error-basic', responses);
              }
              this.$router.go();
            });
        }
      }
    },
    cancelAbesonPhoto() {
      this.$router.go(0);
    }
  }
}
</script>

<style lang="less">
// body {
// display: flex;
// justify-content: center;
// }

.web-camera-container {
  //margin-top: 2rem;
  //margin-bottom: 2rem;
  //padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #000000;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: black;

  .camera-box {
    width: 100%;
    height: 100%;

    .camera-shutter {
      opacity: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }
  }

  .camera-shoot {
    margin: 1rem 0;

    button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: contain;
      }
    }
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-50%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: .2s;
        }

        &:nth-child(3) {
          animation-delay: .4s;
        }
      }
    }
  }

  //   @keyframes preload {
  //     0% {
  //       opacity: 1
  //     }
  //     50% {
  //       opacity: .4
  //     }
  //     100% {
  //       opacity: 1
  //     }
  //   }

  .custom-class {
    width: 100%;
    height: 100%
  }
}

.camera-button {
  margin-bottom: 2rem;
  position: fixed;
  top: 5px;
  left: 5px;
}

.shoot-potrait {
  position: fixed;
  text-align: center;
  width: 100%;
  bottom: 15px;
  left: 0
}

.shoot-landscape {
  position: fixed;
  text-align: center;
  height: 100%;
  right: 15px;
}

.back-potrait {
  text-align: right;
  position: fixed;
  width: 100%;
  bottom: 15px;
  right: 15px
}

.back-landscape {
  text-align: left;
  position: fixed;
  right: 15px;
  bottom: 15px
}

.menu-potrait {
  position: fixed;
  width: 100%;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-landscape {
  height: 100%;
  text-align: center;
  position: fixed;
  right: 15px;
  top: 30px;
  display: inline-grid;
}

.button-list {
  padding-bottom: 15px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.advance-menu {
  bottom: 120px !important;
  width: 100% !important
}

.videouser {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.ant-drawer-body {
  padding: 0px !important;
  height: 100% !important;
  overflow: hidden !important;
}

.ant-drawer-content {
  overflow: hidden !important;
}

.ant-drawer-wrapper-body {
  overflow: hidden !important;
}

.icon-button {
  height: 75px !important;
  width: 75px !important;
}

.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 25px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  background: #04AA6D;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  background: #04AA6D;
  cursor: pointer;
}

.margin-top {
  margin-top: 24px !important;
}

#resultimage {
  object-fit: contain;
}

.bg {
  animation: color 9s infinite linear;
}

.gps_bottom {
  position: fixed;
  bottom: 0px;
}

@keyframes color {
  0% {
    background: #33CCCC;
  }

  20% {
    background: #33CC36;
  }

  40% {
    background: #B8CC33;
  }

  60% {
    background: #FCCA00;
  }

  80% {
    background: #33CC36;
  }

  100% {
    background: #33CCCC;
  }
}
</style>
